import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { ProjectGetter } from '@/store/project/project.module';
import { Project, ProjectAttachment } from '@/store/project/project.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    projectId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const attachments = computed<ProjectAttachment[]>(() => (project.value) ? project.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<ProjectAttachment[]>(() => (project.value) ? project.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    const attachmentClick = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      attachments,
      images,
      attachmentOffcanvas,
      show,
      hide,
      attachmentClick,
    };
  }
});
